import { render, staticRenderFns } from "./RoundLikeNotif.vue?vue&type=template&id=7815dfbd&scoped=true&"
import script from "./RoundLikeNotif.vue?vue&type=script&lang=js&"
export * from "./RoundLikeNotif.vue?vue&type=script&lang=js&"
import style0 from "./RoundLikeNotif.vue?vue&type=style&index=0&id=7815dfbd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7815dfbd",
  null
  
)

export default component.exports